export const oxxioChatbotColors = {
  botMessageBubbleBackground: '{{ neutralColors.neutral25 }}',
  userMessageBubbleBackground: '{{ secondaryColors.green25 }}',
  failedUserMessageBackground: '{{ secondaryColors.red25 }}',
  backgroundChatHeader: '{{ brandColors.brandDarkBlue }}',
  backgroundSendBox: '{{ neutralColors.neutral25 }}',
};
